export default __webpack_public_path__ + "static/media/massup.84853b7c.svg";